<template lang="pug">
	.content-static-pages
		.inside
			h4
				router-link.contextual-link(to='/faq')
					span: | Return to FAQ
			ol(type='1')
				li.head: a(href='#' v-scroll-to="'#c-1'")
					span: | What is Title 24?
				li.head: a(href='#' v-scroll-to="'#c-2'")
					span: | How is Title 24 enforced?
				li.head: a(href='#' v-scroll-to="'#c-3'")
					span: | Who can perform Title 24 compliance analysis?
				li.head: a(href='#' v-scroll-to="'#c-4'")
					span: | Can't I do the documentation myself?
				li.head: a(href='#' v-scroll-to="'#c-5'")
					span: | What information do I need to give to an Energy Consultant?
				li.head: a(href='#' v-scroll-to="'#c-6'")
					span: | Will the Title 24 code change soon?
				li.head: a(href='#' v-scroll-to="'#c-7'")
					span: | What is "glazing percentage?"
				li.head: a(href='#' v-scroll-to="'#c-8'")
					span: | What is conditioned space ?
				li.head: a(href='#' v-scroll-to="'#c-9'")
					span: | What is non-conditioned space ?
				li.head: a(href='#' v-scroll-to="'#c-10'")
					span: | What are HERS measures?

			ol(type='1')
				a(id='c-1')
				li: strong
					| What is Title 24?
				p: | "Title 24" is a huge body of law that contains the practical requirements of the California State Building Code. When building department personnel mention "Title 24," they are usually referring only to sub-section 6 of Title 24 that deals with energy efficiency (so this is somewhat of a misnomer). What's often referred to as "Title 24" could more properly be called the "California Building Energy Efficiency Standards" (acronym: BEES). This part of the Building Code requires a minimum level of energy efficiency for new construction including mere alterations, and for outdoor lighting. The Code is rather complicated, because it allows all sorts of tradeoffs between different energy efficiency measures in the name of construction flexibility. For further information, see our What You Need To Know help sheets:
				ul
					li: a.contextual-link(@click="showModal('What_Additions')")
						strong
							span: | Residential Additions
					li: a.contextual-link(@click="showModal('What_Residential')")
						strong
							span: | New Residences
					li: a.contextual-link(@click="showModal('What_NonResidential')")
						strong
							span: | Commercial
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-2')
				li: strong
					| How is Title 24 enforced?
				p: | Title 24 is enforced by the local or county building department with jurisdiction over your property. Sometimes, plancheck is contracted to a private company. For these reasons, enforcement is very spotty and unpredictable. In theory, you cannot get a building permit for a project covered by BEES (Title 24) until a signed energy compliance report has been deemed correct by a planchecker. Again, in theory, field inspector(s) will check your Title 24 report against your construction at each inspection. In practice, enforcement is never perfect, and is often only cursory. Some energy saving measures require third party (HERS) inspection. HERS inspections are usually quite meticulous.
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-3')
				li: strong
					| Who can perform Title 24 compliance analysis?
				p: | Currently, building energy analysts are not required to hold any license, registration, or certification. There is a private voluntary certification program for energy analysts. Many building departments view certified energy analyst's work favorably, and most of the incentive programs require this certification. EasyTitle24.com has personnel with all relevant qualifications. If you are using our do-it-yourself method, and you intend to apply for an incentive, then you should take extra care to get your data correct. Upon checkout of your project, you will see a certification option.
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-4')
				li: strong
					| Can't I do the documentation myself?
				p: | Yes, you could complete all the energy compliance documentation yourself; however, in nearly all cases, you would experience a huge learning curve, because the Code is quite complicated. For residential projects, EasyTitle24.com provides you with useful tools and helpful information, so that you can do about half the work yourself with a minimal learning curve (provided you can read architectural plans). EasyTitle24.com will complete your project for a deeply discounted fee (i.e. you can earn/save yourself money by using our site).
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-5')
				li: strong
					| What information do I need to give to an Energy Consultant?
				p: | If you use EasyTitle24.com's residential tools, you do not need to submit any information other than the project data you enter on our website. However, please be careful to read relevant Help screens that are linked throughout our forms and in the blue sidebar; otherwise, you may not enter your data correctly. For full service projects, we have prepared help-sheets that will tell you what information is needed:
				ul
					li: a.contextual-link(@click="showModal('What_Additions')")
						strong
							span: | Residential Additions
					li: a.contextual-link(@click="showModal('What_Residential')")
						strong
							span: | New Residences
					li: a.contextual-link(@click="showModal('What_NonResidential')")
						strong
							span: | Commercial
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-6')
				li: strong
					| Will the Title 24 code change soon?
				p: | The California Building Code is on a three year cycle. It changes every three years (2014, 2017, etc.). California has very ambitious goals approaching "net zero energy", so the changes will be significant. Be sure to submit reports [and plans] prepared during the current "code cycle" before the next code takes effect.
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-7')
				li: strong
					| What is "glazing percentage?"
				p: | A glazing percentage is a ratio of fenestration area to conditioned floor area. That is, [total fenestration area] / [conditioned floor area] = [glazing percentage]. The total fenestration area is the sum of the areas (in square feet) of all glazed exterior fenestration units (windows, glass doors, skylights, glass block, etc.), as measured by their outside frame dimensions.In climates that get hot in the summer, going over 5% glazing facing within 45 degrees of due West will result in a very significant energy penalty that will be difficult to compensate for.
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-8')
				li: strong
					| What is conditioned space ?
				p: | Conditioned space is an enclosed space that is provided with wood heating, or is provided with mechanical heating that has a capacity exceeding 10 Btu/hr-ft2, or is provided with mechanical cooling that has a capacity exceeding 5 Btu/hr-ft2. In this category is also "indirectly conditioned space," which is enclosed space that exchanges more heat with conditioned spaces than with exterior spaces and the outdoors.
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-9')
				li: strong
					| What is non-conditioned space ?
				p: | This is space that is not heated nor air conditioned, that is not strongly connected to conditioned space (i.e. not indirectly conditioned), and/or that has un-weatherstripped opening(s) to the outdoors.
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				a(id='c-10')
				li: strong
					| What are HERS measures?
				p: | HERS stands for "Home Energy Rating System." HERS measures are construction components that are required to be inspected and/or tested by a qualified third party "HERS Rater." These measures are called out in the Title 24 report. The person responsible for code compliance-normally the builder-should closely examine the Title 24 report to identify these measures for two important reasons: 1) So that he/she knows what is expected of the actual construction; and 2) So that he/she can line up the HERS Rater early, and learn the details of the special inspection procedure from that person. The building department's role is to ask for, and collect, the applicable HERS compliance forms at the appropriate time(s). The State's role is to promulgate various HERS procedures and govern the system for HERS Rater qualification. Here is a link to the Energy Commission's HERS page:
				a.contextual-link(href='https://www.energy.ca.gov/HERS/' target='_blank')
					strong
						span: | https://www.energy.ca.gov/HERS/
				br
				br
				a(href='#' v-scroll-to="'#home'")
					span: | back to top

		b-modal(id='modal1' ref="myModalRef" hide-footer size="lg" :title="TitlePop")
				div(v-if="PopState === 'What_Residential'")
					what-Do-You-Need-Residential
				div(v-if="PopState === 'What_Additions'")
					what-Do-You-Need-Additions
				div(v-if="PopState === 'What_NonResidential'")
					what-Do-You-Need-Non-Residential

				div(style="width: 100%; display: flex; justify-content:center;")
					b-button(@click="hideModal" variant="outline-success" style="width: 20%;"): | Close
</template>

<script>
import whatDoYouNeedResidential from '@/components/full/pops/residential/whatResidential'
import whatDoYouNeedAdditions from '@/components/full/pops/additions/whatAdditions'
import whatDoYouNeedNonResidential from '@/components/full/pops/nonResidential/whatNonResidential'
export default {
	name: 'faq-c',
	data () {
		return {
			PopState: '',
			TitlePop: 'Title Pop Up'
		}
	},
	components: {
		whatDoYouNeedResidential,
		whatDoYouNeedAdditions,
		whatDoYouNeedNonResidential
	},
	methods: {
		showModal (estado) {
			this.PopState = estado
			this.$refs.myModalRef.show()
			this.changeTitle()
		},
		hideModal () {
			this.PopState = ''
			this.$refs.myModalRef.hide()
		},
		changeTitle () {
			switch (this.PopState[0]) {
			case 'W':
				this.TitlePop = 'What do you need to know'
				break
			case 'T':
				this.TitlePop = 'Transmittal Form'
				break
			default:
				break
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/resources/content-faq-c.vue